import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react";
import { Col, Menu, Row, message } from "antd";
import { BookOutlined, ShoppingCartOutlined, UserAddOutlined } from "@ant-design/icons";
import MyBook from "../../section/myBook";
import { getByUserId } from "../../api/myBook";
import { useDevice } from "../../hooks";
import {
    getBooksOSStoreUrl,
    isAndroidDevice,
    isIOSDevice,
    isMobileBooksOSDevice,
    isWindowsDevice
} from "../../utils/booksOs";

export default function Book() {
    const { isMobile } = useDevice();
    const isAndroid = isAndroidDevice();
    const isIOS = isIOSDevice();
    const isWindows = isWindowsDevice();
    const requiresBooksOS = isMobileBooksOSDevice();
    const booksOSStoreUrl = getBooksOSStoreUrl();
    const navigate = useNavigate();
    const [book, setBook] = useState([]);
    const [category_child_id, setCategoryChildId] = useState(0);
    const [paginationBook, setPaginationBook] = useState({
      page: 1,
      pageSize: 10,
    });
    const user = JSON.parse(localStorage.getItem("user"));

    const items = [
        {
          key: 'order',
          label: <a href="/thong-tin-ca-nhan">Đơn hàng của tôi</a>,
          icon: <ShoppingCartOutlined />
        },
        {
          key: 'my-book',
          label: <a href="/sach-cua-toi">Sách của tôi</a>,
          icon: <BookOutlined />
        },
        {
          key: 'affiliate',
          label: <a href="/tiep-thi-lien-ket">Tiếp thị liên kết</a>,
          icon: <BookOutlined />
        },
        {
          key: 'nhiem-vu-da-nop',
          label: <a href="/nhiem-vu-da-nop">Nhiệm vụ đã nộp</a>,
          icon: <UserAddOutlined />
        },
        {
          key: 'nhiem-vu-hoan-tien-da-nop',
          label: <a href="/nhiem-vu-hoan-tien-da-nop">Nhiệm vụ hoàn tiền đã nộp</a>,
          icon: <UserAddOutlined />
        },
        {
          key: 'change-password',
          label: <a href="/doi-mat-khau">Đổi mật khẩu</a>,
          icon: <UserAddOutlined />
        }
    ];

    useEffect(()=> {        
        const queryBook = `page=${paginationBook?.page}&pageSize=${paginationBook?.pageSize}&category_child_id=${category_child_id}`;
        getByUserId(user?.user_id, queryBook, setBook);
    }, [paginationBook, category_child_id])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
 

    useEffect(() => {
        if(!user?.user_id) {
            navigate("/dang-nhap");
            message.info("Bạn vui lòng đăng nhập để được dùng chức năng này!")
        }
    }, [user]);

    return (
        <div className={`max-w-screen-2xl mx-auto my-5 ${isMobile && "pt-14"}`}>
            {!isMobile && (
            <div className="flex pb-4">
                <a href="">Trang chủ</a> 
                <p className="px-2">/</p> 
                <a href="">Thông tin cá nhân</a>
            </div>
            )}


            {/* WINDOWS_BOOKS_OS_NOTICE */}
            {isWindows && (
                <div className="
                    mx-1 mb-4
                    rounded-xl
                    border border-blue-200
                    bg-blue-50
                    px-4 py-4
                    shadow-sm
                ">
                    <div className="flex items-start gap-3">

                        <div className="
                            mt-[3px]
                            h-3 w-3
                            flex-none
                            rounded-full
                            bg-blue-600
                        " />

                        <div className="min-w-0 flex-1">

                            <p className="
                                m-0
                                text-[16px]
                                font-bold
                                text-blue-800
                            ">
                                OS BOOKS cho Windows
                            </p>

                            <p className="
                                mt-1 mb-3
                                text-[14px]
                                leading-5
                                text-blue-700
                            ">
                                Bạn có thể đọc sách trực tiếp trên website như bình thường.
                                Nếu muốn chỉnh sửa, ghi chú và sử dụng thuận tiện hơn
                                trên máy tính, bạn có thể cài OS BOOKS cho Windows.
                            </p>

                            <a
                                href="/sach-cua-toi/windows"
                                className="
                                    inline-flex
                                    min-h-[42px]
                                    items-center
                                    justify-center
                                    rounded-lg
                                    bg-blue-600
                                    px-5 py-2
                                    text-[14px]
                                    font-bold
                                    text-white
                                    no-underline
                                    hover:bg-blue-700
                                    hover:text-white
                                "
                            >
                                TẢI / CÀI OS BOOKS CHO WINDOWS
                            </a>

                        </div>
                    </div>
                </div>
            )}

            {/* ANDROID_BOOKS_OS_NOTICE */}
            {requiresBooksOS && (
                <div className="
                    mx-1 mb-4
                    rounded-xl
                    border border-red-300
                    bg-red-50
                    px-4 py-4
                    shadow-sm
                ">
                    <div className="flex items-start gap-3">
                        <div className="
                            mt-[3px]
                            h-3 w-3
                            flex-none
                            rounded-full
                            bg-red-600
                        " />

                        <div className="min-w-0 flex-1">
                            <p className="
                                m-0
                                text-[16px]
                                font-bold
                                text-red-700
                            ">
                                Đọc tài liệu bằng OS BOOKS
                            </p>

                            <p className="
                                mt-1 mb-3
                                text-[14px]
                                leading-5
                                text-red-700
                            ">
                                {isIOS
                                    ? "iPhone và iPad cần sử dụng ứng dụng OS BOOKS để đọc tài liệu. Vui lòng mở hoặc tải ứng dụng từ App Store để tiếp tục."
                                    : "Thiết bị Android cần sử dụng Books OS để đọc tài liệu. Vui lòng mở hoặc tải ứng dụng từ Google Play để tiếp tục."}
                            </p>

                            <a
                                href={booksOSStoreUrl}
                                className="
                                    inline-flex
                                    min-h-[42px]
                                    items-center
                                    justify-center
                                    rounded-lg
                                    bg-red-600
                                    px-5 py-2
                                    text-[14px]
                                    font-bold
                                    text-white
                                    no-underline
                                    hover:bg-red-700
                                    hover:text-white
                                "
                            >
                                {isIOS
                                    ? "MỞ / TẢI OS BOOKS TRÊN APP STORE"
                                    : "MỞ / TẢI BOOKS OS TRÊN GOOGLE PLAY"}
                            </a>
                        </div>
                    </div>
                </div>
            )}

            {isMobile ? (
                <div className="w-full">
                    <MyBook
                        book={book}
                        pagination={paginationBook}
                        setPagination={setPaginationBook}
                        setCategoryChildId={setCategoryChildId}
                    />
                </div>
            ) : (
                <Row>
                    <Col xs={24} xl={4} className="p-1">
                        <Menu
                            className="w-full"
                            defaultSelectedKeys={['my-book']}
                            mode="inline"
                            items={items}
                        />
                    </Col>

                    <Col xs={24} xl={20} className="p-1">
                        <MyBook
                            book={book}
                            pagination={paginationBook}
                            setPagination={setPaginationBook}
                            setCategoryChildId={setCategoryChildId}
                        />
                    </Col>
                </Row>
            )}
        </div>
    )
}